var themeConfig = {
  honeycombThemePrefix: 'hcr-theme-',
  honeycombThemes: ['default', 'dark', 'high-contrast', 'kamil', 'legacy', 'neptune']
};

export { themeConfig as default };
